<template>
  <div
    class="accessory-popup-wrap mini"
    id="accessory-popup-wrap"
    :class="{ 'hidden': !$store.state.accessoryPopup.show }"
    v-on:click="hideAccessoryPopup()">
    <div
      class="accessory-popup-content"
      v-on:click="$event.stopPropagation()">
      <button
        class="desktop-close"
        v-on:click="hideAccessoryPopup()"
        aria-label="Close">
        <img aria-hidden="true" src="./../../assets/icons/close.svg"/>
      </button>
      <div class="in-action">
        <img v-if="acc && acc.no_video && accName" :src="getImageUrl(`${ accName }.jpg`)"/>
        <video 
          v-if="acc && !acc.no_video && accName"
          :poster="getPosterUrl(`${ accName }.jpg`)"
          autoplay playsinline muted loop>
          <source 
            :src="getVideoUrl(`${ accName }.mp4`)">
        </video>
      </div>
      <article>
        <header v-if="acc">
          <h4>{{ acc.title }}</h4>
          <div v-if="showPriceEl()">
            <p v-if="$store.getters.popupHiddenPricing">
              Call for Pricing
            </p>
            <p v-else-if="$store.getters.popupAccessoryPricing !== 0">
              {{ formatCurrency($store.getters.popupAccessoryPricing)  }}<span class="list-price">&nbsp;<span v-if="getT">{{getT.static.currency_code}}</span></span>
            </p>
          </div>
        </header>
        <section v-if="acc">
          <p>{{ acc.description }}<span v-if="acc.disclaimer && acc.disclaimer[currPool.tag]"> {{ acc.disclaimer[currPool.tag] }}</span></p>
        </section>
        <section v-if="$store.state.accessories[accName] && !$store.state.accessories[accName].showInScene">
          <p style="color: #087595;">No 3D view available</p>
        </section>
        <button
          class="mobile-close"
          v-on:click="hideAccessoryPopup()">
          <img src="./../../assets/icons/close.svg"/>
        </button>
      </article>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { breakpoint } from '../../styles/style';
import { formatCurrency } from '../../helpers/price.js';

export default {
  name: 'AccessoryPopup',
  props: [ 'accName', 'showPopup', 'isIncluded' ],
  watch: {
    $route () {
      if (this.showPopup) {
        this.hideAccessoryPopup();
      }
    }
  },
  methods: {
    showPriceEl: function() {
      // if site config says don't show pricing, don't show it here
      if (!this.showPricing) {
        return false;
      }

      // if accessory is included, don't show price
      if (this.isIncluded) {
        return false;
      } else {
        return true;
      }
    },
    formatCurrency,
    hideAccessoryPopup() {
      let domAcc = document.querySelector(`#option-accessory-${ this.accName }`);
      let bounds = domAcc.getBoundingClientRect();
      let popup = document.querySelector('#accessory-popup-wrap');
      let popupArticle = document.querySelector('#accessory-popup-wrap article');
      let popupVideo = document.querySelector('#accessory-popup-wrap .in-action video');

      if (popupVideo) {
        popupVideo.pause();
      }

      if (this.$store.state.animations && document.body.clientWidth <= breakpoint.xl) {
        // Mobile
        popup.classList.add('transitions');
        setTimeout(() => {
          popup.classList.add('hide');
          popupArticle.style.top = `${ bounds.top }px`;
          popupArticle.style.maxHeight = `${ domAcc.clientHeight }px`;
          popup.classList.add('mini');
        }, 50);
        setTimeout(() => {
          popup.classList.add('hidden');
          popup.classList.remove('hide');
          popupArticle.style = '';
          popup.classList.remove('transitions');
          this.$store.commit('hideAccessoryPopup');
        }, 800);
      } else {
        // Desktop
        this.$store.commit('hideAccessoryPopup');
      }
    },
    getImageUrl(filename) {
      try {
        var images = require.context('@/assets/images/accessory_images');
        return images('./' + filename);
      } catch(e) {
        console.error('Failed to load image file - ', e);
        return '';
      }
    },
    getPosterUrl(filename) {
      try {
        var images = require.context('@/assets/images/accessory_poster');
        return images('./' + filename);
      } catch(e) {
        console.error('Failed to load accessory poster - ', e);
        return '';
      }
    },
    getVideoUrl(filename) {
      try {
        var videos = require.context('@/assets/videos/accessories');
        return videos('./' + filename);
      } catch(e) {
        console.error('Failed to load video file - ', e);
        return '';
      }
    },
  },
  computed: {
    ...mapGetters(['showPricing', 'getT', 'currPool']),
    acc: function() {
      return this.$store.state.accessories[this.accName];
    },
  }
}
</script>
<style scoped lang="scss">
$z-index: 60;
$video-height: calc(55% - 4em); // Update line 40 in Accessory.vue too!
$option-info-height: calc(45% + 4em);

.accessory-popup-wrap {
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  button.desktop-close {
    display: none;
  }
  .accessory-popup-content {
    position: relative;
    width: 100%;
    max-width: 50em;
    height: 100%;
    background-color: $deep-navy;
    overflow: hidden;
    // Mobile - horizontal orientation
    //@media only screen and (max-width: 1020px) and (min-aspect-ratio: 5/4) {
    @media only screen and (max-width: #{ $xl - 1px }) {
      max-width: 100%;
    }
    .in-action {
      position: absolute;
      z-index: $z-index;
      top: 0;
      width: 100%;
      min-width: 100%;
      height: $video-height;
      max-height: $video-height;
      // transform: scale(1.03); // Weird white space around video
      video, img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    article {
      position: absolute;
      z-index: $z-index;
      top: $video-height;
      height: $option-info-height;
      max-height: $option-info-height;
      width: 100%;
      padding: 1em;
      @media only screen and (max-width: #{ $xl - 1px }) {
        background-color: $deep-navy;
      }
      &::after {
        content: '';
        position: absolute;
        display: block;
        width: 100%;
        height: 6rem;
        bottom: 0;
        background: linear-gradient(rgba(16, 28, 48, 0), rgba(16, 28, 48, 0.7));
        pointer-events: none;
      }
      header {
        max-width: calc(100% - 5.25em);
        padding: .5em 0;
        h4 {
          padding-top: .5em;
          color: white;
          text-transform: uppercase;
          font-size: 1rem;
          letter-spacing: 2.24px;
        }
        @media only screen and (min-width: #{ $xl }) {
          max-width: 100%;
        }
      }
      section {
        overflow-y: auto;
        height: 100%;
        padding: .5em 0 10.5em 0;
        p {
          color: white;
        }
      }
      button.mobile-close {
        position: absolute;
        // Center content - safari won't size svg corrently for some reason
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: $z-index + 1;
        bottom: 1em;
        left: calc(50% - 2em);
        width: 4em;
        height: 4em;
        padding: 1em;
        border-radius: 50%;
        img {
          max-width: 1.5em;
          max-height: 1.5em;
        }
      }
    }
  }
  &.hidden {
    opacity: 0;
    display: none;
  }
  &.hide {
    video {
      opacity: 0;
    }
    .accessory-popup-content article {
      animation: delayed-transparent 700ms ease-out, fade-borders-in 500ms ease-in;
      @keyframes delayed-transparent {
        0% { background-color: $deep-navy; }
        70% { background-color: $deep-navy; }
        100% { background-color: transparent; }
      }
      @keyframes fade-border-in {
        0% { border-top: 1px solid transparent; border-bottom: 1px solid transparent; }
        20% { border-top: 1px solid $deep-slate; border-bottom: 1px solid $deep-slate; }
        100% { border-top: 1px solid $deep-slate; border-bottom: 1px solid $deep-slate; }
      }
      transition: max-height 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                  top 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                  padding 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                  background-color 0ms cubic-bezier(0.645, 0.045, 0.355, 1),
                  margin 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                  border 2000ms cubic-bezier(0.645, 0.045, 0.355, 1) !important;
      section p {
        animation: delayed-opacity 600ms ease-out;
        @keyframes delayed-opacity {
          0% { opacity: 1; }
          60% { opacity: 1; }
          100% { opacity: 0; }
        }
      }
      button.mobile-close {
        transition-duration: 400ms;
      }
    }
  }
  &.show {
    .in-action {
      animation: fade-in 3000ms ease-out;
      @keyframes fade-in {
        0% { max-height: 0 !important; }
        50% { max-height: 0 !important; }
        100% { max-height: $video-height !important; }
      }
    }
    article {
      animation: fade-border-out 600ms ease-out;
      @keyframes fade-border-out {
        0% { border-top: 1px solid $deep-slate; border-bottom: 1px solid $deep-slate; }
        2% { border-top: 1px solid $deep-slate; border-bottom: 1px solid $deep-slate; }
        80% { border-top: 1px solid $deep-slate; border-bottom: 1px solid $deep-slate; }
        100% { border-top: 1px solid transparent; border-bottom: 1px solid transparent; }
      }
      button.mobile-close {
        animation: delayed-opacity-button 500ms ease-out;
        @keyframes delayed-opacity-button {
          0% { opacity: 0; }
          50% { opacity: 0; }
          100% { opacity: 1; }
        }
      }
    }
  }
  &.mini {
    .accessory-popup-content {
      .in-action {
        opacity: 0;
      }
      article {
        padding: 0 1em;
        max-height: 6.1rem;
        overflow: hidden;
        background-color: transparent;
        &::after {
          opacity: 0;
          transition: none;
        }
        header {
          transition: none;
          p {
            opacity: 0;
            transition: none;
          }
        }
        section {
          p {
            opacity: 0;
            transition: none;
          }
        }
        button {
          opacity: 0;
          transition: none;
        }
      }
    }
  }
  &.transitions {
    .accessory-popup-content {
      .in-action {
        transition: opacity 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      article {
        transition: max-height 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                    top 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                    padding 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                    background-color 0ms cubic-bezier(0.645, 0.045, 0.355, 1),
                    margin 500ms cubic-bezier(0.645, 0.045, 0.355, 1),
                    border 2000ms cubic-bezier(0.645, 0.045, 0.355, 1);
        &::after {
          transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
        }
        header {
          transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
          &::after {
            transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
          }
          p {
            transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);
          }
        }
        section {
          &::after {
            transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
          }
          p {
            transition: all 1000ms cubic-bezier(0.645, 0.045, 0.355, 1);
          }
        }
        button {
          transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);
        }
      }
    }
  }

  @media #{$desktop} {
    position: relative;
    z-index: 11;
    backdrop-filter: blur(5px);
    background-color: rgba(0,0,0,0.3);
    animation: fade-in-popup 400ms ease-out;
    @keyframes fade-in-poup {
      from { background-color: transparent; }
      to { background-color: rgba(0,0,0,0.3); }
    }
    .accessory-popup-content {
      width: 70em;
      max-width: calc(100% - 10em);
      height: unset;
      display: flex;
      align-items: center;
      box-shadow: 0 0 30px 10px rgba(0,0,0,0.5);
      button.desktop-close {
        position: absolute;
        top: 1em;
        right: 0;
        display: block;
        background: transparent;
        border: none;
        opacity: .5;
        img {
          width: 1.3em;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .in-action, article {
        position: relative;
        width: 50%;
        min-width: unset;
      }
      .in-action {
        height: 30em;
        animation: none !important;
        overflow: hidden;
        video {
          min-height: 100%;
          transform: scale(1.1);
          animation: fade-in 600ms ease-out;
          @keyframes fade-in {
            0% { opacity: 0; }
            30% { opacity: 0; }
            100% { opacity: 1; }
          }
        }
      }
      article {
        position: unset; 
        padding: 4em;
        display: flex;
        flex-direction: column;
        justify-items: center;
        section {
          padding-bottom: 0;
        }
        button.mobile-close {
          display: none;
        }
      }
    }
  }
}
</style>
